import { render, staticRenderFns } from "./Lavels.vue?vue&type=template&id=5b68a9e6"
import script from "./Lavels.vue?vue&type=script&lang=js"
export * from "./Lavels.vue?vue&type=script&lang=js"
import style0 from "./Lavels.vue?vue&type=style&index=0&id=5b68a9e6&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports